<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <div class="flex">
          <select @change="updateComponent(false, true)" class="form-control" v-model="filter.type">
            <option v-for="(type) in searchTypeOptions" :value="type.typeId">{{
                type.title
              }}
            </option>
          </select>
          <div class="width50">
            <!--            <keep-alive>-->
            <template v-if="filter.type == 5">
              <div class="form-group m-0">
                <DateSelectProps
                  :selectedDate="searchFilter.c1.date"
                  :onSelect="(date) => dateSelected(date)"
                />
              </div>
            </template>
            <component ref="searchValue"
                       :updateFilter="updateFilter"
                       :type="filter.type"
                       :setValue="filter.searchData"
                       :is="searchTypeComponent"/>
            <!--            </keep-alive>-->
          </div>
        </div>
        <div class="form-group" v-if="filter.type != 5">
          <input type="checkbox" v-model="searchFilter.c1.active" id="ch_3">
          <label for="ch_3"> показать с актуальностью сроков годности</label>
        </div>
        <div class="flex">
          <div class="form-group mr-5">
            <input type="radio" :disabled="!searchFilter.c1.active" v-model="searchFilter.c1.search_order"
                   value="before" name="rb" id="ra_1">
            <label for="ra_1"> до</label>
          </div>
          <div class="form-group">
            <input type="radio" :disabled="!searchFilter.c1.active" v-model="searchFilter.c1.search_order" value="after"
                   name="rb" id="ra_2">
            <label for="ra_2"> после</label>
          </div>
        </div>
        <template v-if="filter.type != 5">
          <div class="form-group">
            <DateSelectProps
              ref="calendar"
              :selectedDate="currentDate"
              :onSelect="(date) => dateSelected(date)"
            />
          </div>
        </template>
        <div class="input_100">
          <div class="flex">
            <span>Рассчитавать по курсу</span>
            <input type="text" v-model="profitCalculation.calculatedRate" class="form-control">
            <span>(базовый курс</span>
            <input disabled :value="1 / $AllCurrencies[33].rate" type="text" class="form-control">
            <span>+ коэффициент</span>
            <input type="text" v-model="profitCalculation.ratePercent" class="form-control">
            <span>%)</span>
          </div>
          <div class="flex">
            <span>С расходами на доставку (вычит. из кон. суммы)</span>
            <input type="text" v-model="profitCalculation.deliveryPercent" class="form-control">
            <span>% и</span>
            <input type="text" v-model="profitCalculation.delivery" class="form-control">
            <span>руб.</span>
          </div>
          <div class="flex">
            <span>БАЗОВАЯ НАЦЕНКА</span>
            <input type="text" v-model="profitCalculation.baseMargin" class="form-control">
            <span>процентов</span>
          </div>
          <div class="mb-2">
            <label for="">Предустановленные данные</label>
            <RatePreSet
              :customData="profitCalculation"
              :update="(data) => this.profitCalculation = data"
            />
          </div>
          <div class="mb-2">
            <label for="">Сортировка по закупке</label>
            <select v-model="extraSearchOptions.sorting.purchaseQty" class="form-control">
              <option value="0">Без сортировки</option>
              <option value="1">Наибольшая продажа</option>
              <option value="2">Наименьшая продажа</option>
              <option value="3">Наибольшая закупка</option>
              <option value="4">Наименьшая закупка</option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <input type="checkbox" id="ch_1">
              <label for="ch_1">показать неактивные препараты (найдено 0 неактивных препаратов с ненулевыми остатками на
                складах)</label>
            </div>
            <div class="form-group">
              <input type="checkbox" id="ch_2">
              <label for="ch_2"> показать ТОЛЬКО неактивные препараты</label>
            </div>
            <div class="form-group">
              <input v-model="filter.c3" type="checkbox" id="ch_4">
              <label for="ch_4"> показать себестоимость в рублях</label>
            </div>
            <div>
              <div class="custom-control custom-radio">
                <input type="radio" id="rr1" v-model="filter.c4" value="0" class="custom-control-input">
                <label class="custom-control-label" for="rr1"> без учета ЕГК</label>
              </div>
              <div class="custom-control custom-radio">
                <input type="radio" id="rr2" v-model="filter.c4" value="1" class="custom-control-input">
                <label class="custom-control-label" for="rr2"> показать только препараты с ЕГК</label>
              </div>
              <div class="custom-control custom-radio">
                <input type="radio" id="rr3" v-model="filter.c4" value="2" class="custom-control-input">
                <label class="custom-control-label" for="rr3"> показать только препараты с активными кодами ЕГК</label>
              </div>
              <div class="custom-control custom-radio">
                <input type="radio" id="rr4" v-model="filter.c4" value="3" class="custom-control-input">
                <label class="custom-control-label" for="rr4"> показать только препараты с НЕ активными кодами
                  ЕГК</label>
              </div>
            </div>
            <div class="form-group">
              <input v-model="filter.c11" type="checkbox" id="ch_11">
              <label for="ch_11"> препараты с коэффициентами</label>
            </div>
          </div>
          <div class="col-md-6">
            <div class="custom-control custom-radio">
              <input type="radio" id="sf_pch_1" v-model="extraSearchOptions.sold_filter" value="all_records"
                     class="custom-control-input">
              <label class="custom-control-label" for="sf_pch_1"> все препараты</label>
            </div>
            <div class="custom-control custom-radio">
              <input type="radio" id="sf_pch_2" v-model="extraSearchOptions.sold_filter" value="sold_only"
                     class="custom-control-input">
              <label class="custom-control-label" for="sf_pch_2"> есть продажи за посл. {{ lastStoreRev?.int_data ?? 4}} мес</label>
            </div>
            <div class="custom-control custom-radio">
              <input type="radio" id="sf_pch_3" v-model="extraSearchOptions.sold_filter" value="in_store_no_sale"
                     class="custom-control-input">
              <label class="custom-control-label" for="sf_pch_3"> на складе есть, продаж нет</label>
            </div>
            <div class="custom-control custom-radio">
              <input type="radio" id="sf_pch_4" v-model="extraSearchOptions.sold_filter" value="out_store_no_sale"
                     class="custom-control-input">
              <label class="custom-control-label" for="sf_pch_4"> на складе нет, продаж нет</label>
            </div>
            <div v-if="lastStoreRev?.id" class="alert alert-info">
              <p>Слепок наличия на складах + продажи
                <strong>{{ printDate(lastStoreRev.actual_date, 'DD.MM.YYYY HH:mm') }}</strong> ({{lastStoreRev.int_data}} мес.)</p>
              <p><i>Все склады, кроме списания</i></p>
              <LoadingButton
                title="Сделать слепок продаж"
                className="btn btn-xs btn-outline-info mt-1"
                :onClick="() => saveStoreStatus()"
                :loading="btnLoading.saveStoreStatus"
                :color="$constants.PRIMARY_COLOR"
              />
            </div>
            <hr>
            <div class="form-group">
              <label>
                <input v-model="displaySettings.showIndPrice" type="checkbox">
                отображать индикативную цену
              </label>
            </div>
            <div class="form-group">
              <label>
                <input v-model="displaySettings.showDetailedPercentCalculation" type="checkbox">
                отображать просчет % наценки
              </label>
            </div>
          </div>
        </div>
        <hr>
        <div class="form-group">
          <input v-model="filter.c10" type="checkbox" id="ch_10">
          <label for="ch_10"> сортировать по наличию на складе МСК (max:Склад / min:Продажи)</label>
        </div>
        <div class="flex custom_calculation">
          <select @change="updateCalculation" class="form-control" v-model="calculation.currency">
            <option v-for="curr in $AllCurrencies" :value="curr.id">{{ curr.currency }}</option>
          </select>
          <div>
            <input type="number" disabled
                   :value="Math.round(1/ $AllCurrencies[calculation.currency].rate * 10000)/10000" class="form-control">
          </div>
          <div>
            <input @change="updateCalculation" v-model="calculation.cost" placeholder="Себестоимость" type="text"
                   class="form-control">
          </div>
          <div>
            <input @change="updateCalculation" v-model="calculation.price" placeholder="Стоимость" type="number"
                   class="form-control">
          </div>
          <div>
            <input v-model="calculation.percent" disabled type="text" class="form-control">
          </div>
        </div>
        <div class="mt-2">
          <template v-if="!showChangeDefaultSupplier">
            <div class="text-right">
              <button @click="showChangeDefaultSupplier = true" type="button" class="btn btn-default">Сменить поставщика
                по умолчанию
              </button>
            </div>
          </template>
          <template v-else>
            <SetDefaultSupplier/>
          </template>
          <div class="form-group mt-1">
            <input v-model="filter.showOrderedInvoices" type="checkbox" id="ch_12">
            <label for="ch_12"> показать заказ препаратов</label>
          </div>
          <div v-if="getTasksByType(17)" class="flex flex_gap_10 mb-2">
            <h4 class="mb-0">у Вас <strong>{{ getTasksByType(17).total_tasks }}</strong> активных задач</h4>
            <LoadingButton
              title="посмотреть"
              type="button"
              :loading="btnLoading.openTasks"
              :color="$constants.PRIMARY_COLOR"
              :onClick="() => openTasks()"
              className="btn btn-outline-info btn-xs"
            />
          </div>
        </div>
      </div>
      <div v-if="false" class="col-md-12">
        <div class="letters_block">
          <button type="button" @click="searchByLetter(letter)" v-for="(letter) in rusArr" class="btn btn-success">
            {{ letter }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import SearchText from "./SearchText";
import SearchSelect from "./SearchSelect";
import SearchDate from "./SearchDate";
import Datepicker from 'vuejs-datepicker'
import {en, ru} from 'vuejs-datepicker/dist/locale'
import moment from 'moment';
import RatePreSet from './RatePreSet'
import SetDefaultSupplier from "@/views/suppliers/components/SetDefaultSupplier";
import api from "@/api";
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import DateSelect from "@/views/reports/components/DateSelect.vue";
import DateSelectProps from "@/components/dateSelect/DateSelectProps.vue";

export default {
  props: ['preset', 'search', 'page', 'showOrderedDrugs', 'lastStoreRev', 'updateDisplaySettings'],
  components: {
    DateSelectProps,
    DateSelect,
    LoadingButton,
    SetDefaultSupplier,
    SearchText,
    SearchSelect,
    SearchDate,
    Datepicker,
    RatePreSet,
  },
  computed: {
    $AllCurrencies() {
      return this.$store.getters['platform/currencies'];
    },
  },
  mounted() {
    this.updateProfitCalculation();
    this.updateFilterFromLink();
    // this.updateUrl(true);
  },
  data() {
    return {
      btnLoading: {
        openTasks: false,
        saveStoreStatus: false,
      },
      displaySettings: {
        showIndPrice: false,
        showDetailedPercentCalculation: false,
      },
      showChangeDefaultSupplier: false,
      calculation: {
        currency: 28,
        cost: null,
        price: null,
        percent: null
      },
      currentDate: new Date(),
      searchFilter: {
        c1: {
          active: false,
          alias: 'validDate',
          search_order: 'before',
          date: moment(this.currentDate).format('DD.MM.YYYY')
        }
      },
      extraSearchOptions: {
        sold_filter: 'all_records',
        sorting: {
          purchaseQty: 0,
        },
      },
      filter: {
        type: 1,
        showOrderedInvoices: false,
        date: moment(this.currentDate).format('DD.MM.YYYY')
      },
      profitCalculation: {},
      locality: ru,
      searchTypeComponent: SearchText,
      searchTypeOptions: [
        {typeId: 1, title: 'по названию'},
        {typeId: 2, title: 'по мориону'},
        // {typeId: 3, title: 'по валюте'},
        {typeId: 4, title: 'по стране закупки'},
        {typeId: 5, title: 'по сроку годности'},
      ],
      rusArr: ['А', 'Б', 'В', 'Г', 'Д', 'Е', 'Ё', 'Ж', 'З', 'И', 'Й', 'К', 'Л', 'М', 'Н', 'О', 'П', 'Р', 'С', 'Т', 'У', 'Ф', 'Х', 'Ц', 'Ч', 'Ш', 'Щ', 'Э', 'Ю', 'Я'],
    }
  },
  watch: {
    'displaySettings': {
      handler: function (val, oldVal) {
        if (this.updateDisplaySettings) this.updateDisplaySettings({...this.displaySettings});
      },
      deep: true
    },
    'filter.showOrderedInvoices': {
      handler: function (val, oldVal) {
        if (this.showOrderedDrugs) {
          this.showOrderedDrugs(this.filter.showOrderedInvoices)
        }
      },
    }
  },
  methods: {
    async saveStoreStatus() {
      this.btnLoading.saveStoreStatus = true;
      const {data} = await api.index('/new/stores/update/dynamic');
      if (data.success) {
        toastr['success']('Слепок наличия на складах запущен');
      } else {
        toastr['error']('Ошибка при обновлении слепка наличия на складах');
      }
      this.btnLoading.saveStoreStatus = false;
    },
    async openTasks() {
      this.btnLoading.openTasks = true;
      const {data} = await api.index('/tasks/type/17?noPagination=1');
      if (data.success) {
        if (data.records.length) {
          this.$store.dispatch('platform/setGlobalDrawerData', {
            data: {
              records: data.records,
              type: 'priceChangeTasks'
            },
          });
        }
      }
      this.btnLoading.openTasks = false;
    },
    getTasksByType(typeId) {
      const tasks = (this.$ActiveNotifications?.all_tasks ?? []).find((t) => t.type_id === +typeId);
      return tasks ?? false;
    },
    updateCalculation() {
      if (!this.calculation.cost) return;
      const price = this.calculation.cost * this.$AllCurrencies[this.calculation.currency].rate / this.$AllCurrencies[33].rate;
      if (!this.calculation.price) {
        const sum = price + (price * +(this.profitCalculation.baseMargin || 0) / 100) + +(this.profitCalculation.delivery || 0);
        this.calculation.price = Math.round(sum + (sum * +(this.profitCalculation.deliveryPercent || 0) / 100));
      }
      const setPrice = +this.calculation.price - (+this.calculation.price * +(this.profitCalculation && this.profitCalculation.deliveryPercent || 0) / 100) - +(this.profitCalculation && this.profitCalculation.delivery || 0);
      this.calculation.percent = (Math.round(setPrice * 100 / price) - 100) + '%';
    },
    updateProfitCalculation(field = null) {
      this.profitCalculation.delivery = 380;
      this.profitCalculation.deliveryPercent = 10;
      this.profitCalculation.ratePercent = 6;
      this.profitCalculation.baseMargin = 100;
      this.profitCalculation.calculatedRate = (1 / this.$AllCurrencies[33].rate) + ((1 / this.$AllCurrencies[33].rate) * this.profitCalculation.ratePercent / 100);
    },
    searchByLetter(letter) {
      this.filter.searchData = null;
      this.$refs.searchValue.value = null;
      this.filter.lt = letter;
      this.search();
    },
    openCalendar() {
      this.$refs.calendar.showCalendar();
    },
    dateSelected(e, type = false) {
      console.log(e);
      this.filter.date = moment(e).format('DD.MM.YYYY');
      this.searchFilter.c1.date = this.filter.date;
      return;
      if (e?.target?.value) {
        this.searchFilter.c1.date = moment(e.target.value, 'DD.MM.YYYY').toISOString();
      } else {
        this.searchFilter.c1.date = moment(e).toISOString();
      }
      if (type) {
        if (e?.target?.value) {
          this.currentDate = moment(e.target.value, 'DD.MM.YYYY').toISOString();
        } else {
          this.currentDate = moment(e).toISOString();
        }
      } else {
        if (e?.target?.value) {
          this.filter.date = moment(e.target.value, 'DD.MM.YYYY').format('DD.MM.YYYY');
        } else {
          this.filter.date = moment(e).format('DD.MM.YYYY');
        }
      }
      this.searchFilter.c1.date = this.filter.date;
    },
    updateFilterFromLink() {
      const data = this.$route.query;
      this.updateComponent(data.type);
      Object.keys(data).forEach((k) => {
        switch (k) {
          case 'searchData':
            this.$refs.searchValue.value = data[k];
            break;
          default:
            this.filter[k] = data[k];
            break;
        }
      });
      this.filter = {...this.filter};
      this.updateFilter();
    },
    updateUrl(page) {
      let filter = {};
      let str = ''
      this.filter.page = page;
      Object.keys(this.filter).forEach((k) => {
        switch (k) {
          default:
            if (this.filter[k]) {
              if (typeof this.filter[k] !== 'object') {
                filter[k] = this.filter[k];
                if (str != "") str += "&";
                str += k + '=' + encodeURIComponent(this.filter[k]);
              }
            }
            break;
        }
      });
      window.history.pushState(null, null, this.$route.path + '?' + str);
    },
    updateFilter(page = 1) {
      this.filter.searchData = this.$refs.searchValue && this.$refs.searchValue.value || {};
      if (this.filter.searchData) {
        this.filter.lt = null;
      }
      this.filter.searchOptions = {...this.searchFilter}
      // if (this.filter.type === 5){
      //   this.filter.exdt = this.$refs.searchValue.value;
      // }
      this.updateUrl(page);
    },
    updateComponent(typeId = false, reset = false) {
      this.searchFilter.c1.active = false;
      if (!typeId) {
        typeId = this.filter.type;
      }
      switch (+typeId) {
        case 3:
        case 4:
          this.searchTypeComponent = SearchSelect;
          break;
        case 5:
          this.searchTypeComponent = null;
          this.searchFilter.c1.active = true;
          break;
        default:
          this.searchTypeComponent = SearchText;
          break;
      }
      if (reset) {
        if (this.$refs.searchValue) {

          this.$refs.searchValue.value = null;
        }
      }
      this.updateFilter();
    }
  }
}

</script>

<style scoped>
.input_100 input {
  max-width: 90px;
  margin: 0 5px;
}

.input_100 .flex {
  margin-bottom: 5px;
}

.letters_block .btn {
  font-size: 11px;
  padding: 4px 8px !important;
}

.width50 {
  min-width: 50%;
}

.letters_block button {
  margin-right: 3px;
  margin-bottom: 5px;
}

.form-group {
  margin-bottom: 5px;
  display: flex;
}

.form-group input {
  margin-top: 5px;
  margin-right: 5px;
}

.form-group label {
  cursor: pointer;
  margin-bottom: 2px;
}

.custom_calculation select {
  width: 100px;
}
</style>
